import { render, staticRenderFns } from "./KiPdf.vue?vue&type=template&id=36468edb&scoped=true"
import script from "./KiPdf.vue?vue&type=script&lang=js"
export * from "./KiPdf.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36468edb",
  null
  
)

export default component.exports